<template>
    <div class="buyerBindingCheck">
        <div class="search">
            <el-input v-model.trim="keywords" placeholder="推广员昵称、推广员手机号"></el-input>
            <el-button @click.native="search">搜索</el-button>
        </div>
        <el-table ref="multipleTable" :data="tableData" style="width: 100%">
            <el-table-column prop="clientnickname" label="买家昵称"></el-table-column>
            <el-table-column prop="promoternickname" label="推广员昵称" class-name="center"></el-table-column>
            <el-table-column prop="promotermobileno" label="推广员手机号" class-name="center"></el-table-column>
            <el-table-column prop="bindtime" label="绑定时间" class-name="center"></el-table-column>
            <el-table-column prop="cancelbindtime" label="解绑时间" class-name="center"></el-table-column>
            <el-table-column label="状态" class-name="center">
                <template slot-scope="scope">
                    <div class="bindStatus">
                        <span v-if="scope.row.status === 0">失败</span>
                        <span v-if="scope.row.status === 1">成功</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Page ref="page" :total="total"></Page>
    </div>
</template>
<script>
import Page from '@/base/page/page'
import {buyBindingList} from '@/api/extensionAgent'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'buyerBindingCheck',
    data() {
        return {
            total: 0,
            keywords: '',
            tableData: [
                {clientnickname: 'Jason', promoternickname: 'Anderson', promotermobileno: '12345678909', statustext: '成功', bindtime: '2019.07.07  12:12:12', cancebindtime: '2019.07.07  12:12:12'}
            ]
        }
    },
    mounted() {
        this.getBuyBindingList()
    },
    methods: {
        getBuyBindingList() {
            this.setLoading(true)
            buyBindingList({
                data: Object.assign({}, {keywords: this.keywords}, this.$refs.page.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data
                    this.total = data.pageableData.rowCount
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        search() {
            this.getBuyBindingList()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        Page
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
    .buyerBindingCheck{
        .search{
            margin-top: 15px;
            .el-input{
                width: 330px;
                margin-right: 30px;
            }
        }
        .el-table{
            margin-top: 30px;
            .center{
                .cell{
                    text-align: center;
                }
            }
        }
    }
</style>